﻿<template>
  <div class="landing-root">

    <div class="landing-scroll">

      <!-- HERO — Slider.vue owns the whole thing, no wrapper override -->
      <div class="hero">
        <slider />
      </div>

      <!-- EXPERIENCES -->
      <div class="experiences">
        <div class="exp-title">Browse Experiences</div>
        <div class="exp-sub">Activities, stays, and camping — all at Ol Pejeta</div>

        <div class="tabs">
          <button
            class="tab"
            :class="{ active: tab === 'activities' }"
            @click="tab = 'activities'"
          >
            <v-icon small :color="tab === 'activities' ? '#fff' : '#3f632b'">mdi-hiking</v-icon>
            <span>Activities</span>
          </button>
          <button
            class="tab"
            :class="{ active: tab === 'stays' }"
            @click="tab = 'stays'"
          >
            <v-icon small :color="tab === 'stays' ? '#fff' : '#3f632b'">mdi-bed</v-icon>
            <span>Stays</span>
          </button>
          <button
            class="tab"
            :class="{ active: tab === 'camping' }"
            @click="tab = 'camping'"
          >
            <v-icon small :color="tab === 'camping' ? '#fff' : '#3f632b'">mdi-tent</v-icon>
            <span>Camping</span>
          </button>
        </div>

        <div class="tab-panel" v-show="tab === 'activities'">
          <activities />
        </div>
        <div class="tab-panel" v-show="tab === 'stays'">
          <accomodations />
        </div>
        <div class="tab-panel" v-show="tab === 'camping'">
          <camp-sites />
        </div>
      </div>

      <div class="hint">
        <v-icon small color="#74a533">mdi-information-outline</v-icon>
        <span class="hint-text">
          You can complete a booking without creating an account.
        </span>
      </div>
    </div>

    <!-- FLOATING START BOOKING — always reachable -->
    <button class="floating-cta" @click="startBooking">
      <v-icon small color="#ffffff">mdi-calendar-check</v-icon>
      <span>Start Booking</span>
    </button>

  </div>
</template>

<script>
import Slider from '../Repeated/Slider.vue'
import Activities from '../../Back/Guests/Activities.vue'
import Accomodations from '../../Back/Guests/Accomodation.vue'
import CampSites from '../../Back/Guests/CampSites.vue'

export default {
  name: 'Index',
  components: { Slider, Activities, Accomodations, CampSites },
  data() {
    return {
      tab: 'activities'
    }
  },
  methods: {
    startBooking() {
      this.$router.push('/new-bookings')
    }
  }
}
</script>

<style scoped>
.landing-root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
}

.landing-scroll {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 110px;
}

/* ---------- HERO — Slider.vue renders full-size; no wrapper override ---------- */
.hero {
  position: relative;
  width: 100%;
  overflow: hidden;
}

/* ---------- EXPERIENCES ---------- */
.experiences { padding: 22px 10px 0; }
.exp-title {
  font-size: 17px; font-weight: 700;
  color: #2d4a1e;
  margin-bottom: 4px; padding: 0 8px;
}
.exp-sub {
  font-size: 12.5px; color: #5e6e4e;
  margin-bottom: 14px; padding: 0 8px;
}

.tabs {
  display: flex; gap: 6px;
  margin-bottom: 14px; padding: 0 8px;
}
.tab {
  flex: 1;
  display: flex; align-items: center; justify-content: center;
  gap: 5px;
  border: 1px solid rgba(116, 165, 51, 0.35);
  background: #ffffff;
  color: #3f632b;
  font-weight: 600; font-size: 11.5px;
  padding: 8px 4px;
  border-radius: 40px;
  cursor: pointer;
  white-space: nowrap;
}
.tab.active {
  background: #3f632b;
  border-color: #3f632b;
  color: #ffffff;
}

.tab-panel { padding: 0 4px; }

/* ---------- HINT ---------- */
.hint {
  display: flex; align-items: center; justify-content: center;
  gap: 6px; margin: 22px 12px 0; padding: 0 8px;
}
.hint-text {
  font-size: 11.5px; color: #5e6e4e; text-align: center;
}

/* ---------- FLOATING CTA ---------- */
.floating-cta {
  position: fixed;
  right: 18px;
  bottom: calc(18px + env(safe-area-inset-bottom));
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  cursor: pointer;
  background: #74a533;
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  padding: 14px 22px;
  border-radius: 40px;
  box-shadow: 0 10px 26px -6px rgba(116, 165, 51, 0.55),
              0 4px 12px -4px rgba(0, 0, 0, 0.2);
  z-index: 55;
  transition: transform 0.12s, box-shadow 0.12s;
}
.floating-cta:hover {
  box-shadow: 0 14px 30px -6px rgba(116, 165, 51, 0.7),
              0 6px 16px -4px rgba(0, 0, 0, 0.25);
}
.floating-cta:active {
  transform: scale(0.96);
}

/* ---------- Mobile ---------- */
@media (max-width: 600px) {
  .experiences { padding: 18px 6px 0; }
  .exp-title { font-size: 15px; }
  .exp-sub { font-size: 11.5px; }
  .tab { font-size: 11px; padding: 7px 2px; }
  .tab-panel { padding: 0; }

  .floating-cta {
    right: 14px;
    bottom: calc(14px + env(safe-area-inset-bottom));
    padding: 12px 18px;
    font-size: 13px;
  }
}
</style>